<mat-form-field class="full-width">
	<mat-label>{{ props.label }}</mat-label>
	<input matInput [placeholder]="props.placeholder" [formControl]="filterCtrl" (focus)="open()" aria-haspopup="listbox">
	<mat-select #select [formControl]="formControl" [disableOptionCentering]="true" [panelClass]="'custom-select-panel'">
		<mat-option *ngFor="let option of filteredOptions | async" [value]="option.value">
			{{ option.label }}
		</mat-option>
	</mat-select>
</mat-form-field>